// Copyright (c) 2025 Deere & Company

const allowedColumnSeparatorKeys = ['1', '2'];

const columnSeparators = {
    1: ',',
    2: ';',
};

export const getColumnSeparator = (key) => key && allowedColumnSeparatorKeys.includes(key) ? columnSeparators[key] : ',';
